import React, { InputHTMLAttributes, ReactNode, Ref, forwardRef } from 'react';
import { cn } from '../../../utils';

export type TextInputProps = Omit<
  InputHTMLAttributes<Omit<HTMLInputElement, 'type'>>,
  'prefix'
> & {
  prefix?: ReactNode;
  extraClassname?: string;
  error?: boolean;
  isFilter?: boolean;
  button?: ReactNode;
};

export const TextInput = forwardRef(
  (props: TextInputProps, ref: Ref<HTMLInputElement>) => {
    const { extraClassname, prefix, error, isFilter, button, ...rest } = props;

    return (
      <div
        className={cn(
          'border-evolve-primary focus-visible:!border-evolve-highlight-50 !border-2 !p-2 text-sm focus-visible:!outline-none',
          {
            '!border-evolve-highlight-500 !bg-evolve-shadow-secondary':
              isFilter,
            'bg-evolve-secondary': rest.disabled,
          },
          extraClassname,
          { '!border-red-500 !shadow-red-500': error },
          { 'flex flex-row items-center justify-between': !!button },
        )}
      >
        {prefix && (
          <span className="!border-evolve-primary !inline-flex items-center !border-2 !border-r-0 px-2 font-semibold">
            {prefix}
          </span>
        )}

        <input
          ref={ref}
          {...rest}
          type="text"
          className={
            'w-full bg-transparent ring-0 focus:ring-0 focus-visible:!outline-none'
          }
        />
        {button && button}
      </div>
    );
  },
);

TextInput.displayName = 'TextInput';
